import React from 'react';
import cn from 'classnames';
import LazyImage from 'components/UI/LazyImage';
import Link from 'components/UI/Link';
import Icon from 'components/UI/Icon';
import { useTrans } from 'utils/localisation';

import * as styles from './ReviewCard.module.scss';

export default function ReviewCard({
  className,
  name,
  photo,
  linkedin,
  position,
  company,
  company_link,
  short_description,
  verified,
  firstTabLabel,
  setActive,
}) {
  const t = useTrans(['common']);
  const isClutch = verified?.type === 'Clutch.co';

  const handleClick = () => {
    setActive(firstTabLabel);
    setTimeout(handleScroll, 100);
  };

  return (
    <div className={cn(styles.card, className)}>
      <div className={styles.cardTop}>
        <LazyImage className={styles.photo} src={photo} alt={name ?? 'Person'} />
        <div className={styles.caption}>
          {name &&
            (linkedin ? (
              <Link href={linkedin} className={styles.name}>
                {name}
                <Icon name="linkedin-square" className={styles.linkedinIcon} />
              </Link>
            ) : (
              <p className={styles.name}>{name}</p>
            ))}
          <p className={styles.position}>
            {position}{' '}
            {company_link ? (
              <Link href={company_link} className={styles.companyLink}>
                {company}
              </Link>
            ) : (
              <span>{company}</span>
            )}
          </p>
        </div>
        {isClutch && (
          <Link href={verified?.link} className={styles.clutchLink}>
            <LazyImage
              className={styles.clutchIcon}
              src="https://static.andersenlab.com/andersenlab/new-andersensite/icons/clutch-verified-color.svg"
              alt="Clutch.co"
            />
          </Link>
        )}
      </div>
      <div className={styles.textWrapper}>
        <p className={styles.text}>{short_description}</p>
        <div className={styles.link} onClick={() => handleClick()}>
          {t('readMore')}
        </div>
      </div>
    </div>
  );
}

function handleScroll() {
  const offset = 180;
  const scrollTarget =
    document.getElementById('review').getBoundingClientRect().top -
    document.body.getBoundingClientRect().top -
    offset;
  window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
}
